<template>
    <div class="container-fluid forms-search-container">
        <div class="row">
            <div class="col-12" />
        </div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <form
                            action=""
                            @submit.prevent="searchFormSubmit()"
                            class="form-inline"
                        >
                            <div class="input-group col-12 col-md-4">
                                <input
                                    type="search"
                                    name="keyword"
                                    id="keyword"
                                    placeholder="Search..."
                                    v-model.lazy="keyword"
                                    class="form-control"
                                    @input="searchFormSubmit"
                                >
                            </div>
                            <button class="btn btn-primary mr-sm-2">
                                <i class="fa fa-search" /> Search
                            </button>
                            <button
                                class="btn btn-success mr-sm-2"
                                type="button"
                                @click.prevent="newForm()"
                            >
                                <i class="fa fa-plus" /> New Form
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <table
                            class="table"
                            v-if="forms.length"
                            :class="{disabled: loading}"
                        >
                            <thead>
                                <tr>
                                    <th>Vehicle</th>
                                    <th>Engineer</th>
                                    <th>Date</th>
                                    <th>Created</th>
                                    <th>Updated</th>
                                    <th />
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(form, index) in forms"
                                    :key="index"
                                >
                                    <td>
                                        <router-link
                                            :to="{name: 'office.forms.edit', params: { id: form.id }}"
                                            title="Edit Form"
                                        >
                                            {{ form.vehicle_reg }}
                                        </router-link>
                                    </td>
                                    <td>
                                        <router-link
                                            :to="{name: 'office.forms.edit', params: { id: form.id }}"
                                            title="Edit Form"
                                        >
                                            {{ form.engineer ? form.engineer.name : '-' }}
                                        </router-link>
                                    </td>
                                    <td>
                                        {{ form.test_date | date }}
                                    </td>
                                    <td>
                                        {{ form.created_at | datetime }}
                                    </td>
                                    <td>
                                        {{ form.updated_at | datetime }}
                                    </td>
                                    <td>
                                        <router-link
                                            :to="{name: 'office.forms.edit', params: { id: form.id }}"
                                            title="Edit Form"
                                        >
                                            <i class="fa fa-pencil-alt" />
                                        </router-link>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <pagination
                            :page="page"
                            :last-page="lastPage"
                            @pageChange="pageChange"
                        />
                        <span
                            class="pagination-stats"
                            v-if="total > 0"
                        >Showing {{ from }} - {{ to }} out of {{ total }}</span>
                        <span v-if="!forms.length && !loading">No forms to show</span>
                        <i
                            class="fa fa-spinner fa-pulse mb-2 mr-sm-2"
                            v-if="loading"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FormService from "../../services/FormService";
import AuthService from "../../services/AuthService";
import Pagination from "../PaginationComponent.vue";
import * as Form from "../../include/Form";
import _ from 'lodash';
import UsesErrors from '../../mixins/UsesErrors';

export default {
    components: {
        pagination: Pagination
    },
    mixins: [UsesErrors],
    data: function () {
        return {
            forms: [],
            loading: false,
            token: null,
            lastPage: 1,
            perPage: 50,
            from: 1,
            to: 1,
            total: 0,
            types: Form.types,
        };
    },
    computed: {
        keyword: {
            get() {
                return this.$route.query.keyword || '';
            },
            set(value) {
                this.$router.replace({query: {
                    ...this.$route.query,
                    keyword: value,
                }});
            }
        },
        page: {
            get() {
                return parseInt(this.$route.query.page || '1');
            },
            set(value) {
                this.$router.replace({query: {
                    ...this.$route.query,
                    page: value,
                }});
            }
        },
    },
    watch: {
        $route: {
            immediate: true,
            handler() {
                this.searchForms();
            },
        }
    },
    mounted: function () {
    },
    methods: {
        searchFormSubmit: _.debounce(function() {
            this.page = 1;
        }, 500),
        searchForms: function () {
            this.loading = true;
            FormService.search({
                page: this.page,
                keyword: this.keyword,
                type: 'weekly_functional_test',
            }).then(
                res => {
                    this.forms = res.data.data;
                    this.lastPage = res.data.last_page;
                    this.perPage = res.data.per_page;
                    this.total = res.data.total;
                    this.from = res.data.from;
                    this.to = res.data.to;
                    this.loading = false;
                },
                err => {
                    this.loading = false;
                    this.setErrorMessage("Error: Could not load forms");
                    console.error(err);
                }
            );
        },
        pageChange: function(page) {
            this.page = page;
        },
        newForm: function () {
            this.$router.push({
                name: 'office.forms.new',
                query: {
                    type: 'weekly_functional_test',
                }
            })
        },
    }
};
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/office/WeeklyFunctionalTestIndex.vue